const enQuote = {
  quote: {
    label: {
      title: 'Quote',
      name: 'Name',
      amount: 'Value',
      category: 'Category',
      location: 'Location',
      quantity: 'Quantity',
      cardInfo: 'Card Information',
      personalInfo: 'Personal Information',
      itemDescription: 'Item Description',
      itemDesc: 'Item Desc.',
      serviceDescription: 'Service Description',
      serviceDesc: 'Service Desc.',
      instalmentNumber: 'Installments',
      poweredByAlt: 'Powered by Hauseful',
      printableVersion: 'Printable Version',
      print: 'Print',
      share: 'Share',
      accepted: 'Accepted',
      notAccepted: 'Not accepted',
      displayQRCode: 'View QR Code',
      paymentMethod: 'Payment Method',
      qtd: 'Qty.',
      phone: 'Phone',
      email: 'Email',
      simplifiedPrinting: 'Simplified printing',
    },

    modal: {
      pix: 'PIX',
      payWith: 'Pay with',
      creditCard: 'Credit Card',
      paymentSelectTitle: 'Select Payment Method',
      payWithFciTitle: 'Confirm Proposal Acceptance',
      paymentSelected: 'Payment Information',
      availableInstallments: 'Installment Options',
      seeAvailableInstallments: 'View installment options',
      availableInstallmentsDescription: 'You can choose the number of installments at the time of payment.',
      fci: 'FCI',
      installmentTerm: 'Term',
      installmentMonthlyValue: 'Monthly Value',
      installmentTotalValue: 'Total Value',
    },

    action: {
      goBack: 'Go Back',
      pay: 'Buy Now',
      useAnotherMethod: 'Use Another Payment Method',
      makePayment: 'Complete Order',
      paymentSelect: 'Select Payment Method',
      acceptQuote: 'Accept Quote',
    },

    share: {
      subject: 'Hauseful Quote',
      message: 'Here is the link to view the quote: ',
    },

    hint: {
      withPix: 'via PIX with {discount} discount',
      notFound: 'Quote not found',
      alreadyPaid: 'Quote paid',
      awaitingPayment: 'Awaiting payment via PIX',
      addressAndCode: 'Below are the items related to the renovation service to be carried out at the property {address} with code {code}',
      afterPaymentGetInTouch: 'After making the payment, our team will contact you to schedule the service and address any questions.',
      paymentSuccess: 'Payment has been successfully made!',
      paidWithFci: 'The quote was paid with FCI balance',
      payWithFci: 'The quote can be paid with FCI balance',
      paymentAcceptedAndPaid: 'Quote paid by the tenant',
      paymentPaidByBalance: 'Quote paid using balance',
      paid: 'The quote has been paid',
      keyWithTenant: 'Quote accepted and awaiting payment',
      willBePaidWithFCI: 'Payment via FCI with {value} discount',
      paymentAmountAndMethod: 'Payment of {amount} made via {method}',
      paymentMethodWithoutAmount: 'Payment made via {method}',
      paymentMethodAndFCIWithoutAmount: 'Payment made via {method} and F.C.I.',
      onSightDiscount: 'With a discount for immediate payment of {discount}',
      installments: 'In {installments} installment(s)',
      overdue: 'This quote is overdue',

      totalPayment: 'Total: {summaryTotal}',
      totalPixPayment: 'PIX in the amount of {summaryChargedValue}',
      totalInstallment: '{summaryInstallments} installment of {summaryInstallmentValue}',
      totalInstallments: '{summaryInstallments} installments of {summaryInstallmentValue} ({chargedValue})',
      totalFCI: 'FCI used: {summaryFCI}',
    },

    share: {
      title: 'Sharing',
      label: {
        type: 'Type',
        sendTo: 'Sent to',
        shared: 'Shared',
        viewed: 'Viewed',
      },
      type: {
        PHONE: 'Phone',
        EMAIL: 'Email',
      }
    },

    amount: {
      title: 'Transfers',
      itemsValues: 'Vendor',
      splitValues: 'Split',
      showTransfer: 'View Transfer'
    },

    priceTable: {
      subtotal: 'Subtotal',
      fci: 'FCI',
      usedFci: 'FCI used',
      discount: 'Discount',
      total: 'Total',
      payWithPix: 'PIX',
      totalWithDiscount: 'Total with discount',
      totalByInstallments: 'or {totalByInstallments} in up to 10x',
      cashDiscount: 'Cash discount',
      discountPIXHint: 'with PIX',
      discountPIXAmount: '10% discount',
      installments: 'in up to {installments}x',
      installmentsNumber: 'with PIX or in up to {installments} times',
      singleInstallmentNumber: 'with PIX or in up to {installments} time on the card',
      payment: 'Payment',
      usingFCI: 'completely covered by the F.C.I. balance',
      usingBalance: 'using your balance',
      serviceCallFee: 'Technical Visit',
      vendorDiscount: 'Discount',
      pixTax: 'Service Fee',
      technicalVisitDescription: 'Amount charged for the technical visit and service execution.',
    },
  },
};

export default enQuote;
